module.exports = __webpack_public_path__ + "assets/img/Return.2be880e1.svg";